// DEV 확인 계정 — 개발요청 상세의 «할 일» 상자 바로 아래 한 줄(AX 만 · 그리는 쪽은 DevRequestDetail).
//   발급·재발급 = DEV 가 계정을 만든 뒤(applied) 서버 스케줄러가 요청자에게 메신저 DM 으로 DEV 아이디·비밀번호를 보낸다
//   (발급 순간엔 DM 이 없다) · 회수 = DM 없음.
//   발급은 상태 «테스트»·«완료» · 철회 아님 · 요청자 연결일 때만 · 살아 있는 계정은 상태·철회와 무관하게 회수할 수 있다.
// 🔴 비밀번호는 화면·상태 어디에도 없다 — 응답에도 없고 pick 이 아는 10개 키 밖은 버린다.
// 🔴 busy 는 확인창보다 먼저 켠다 — 두 번 누르면 두 번 발급돼 첫 비밀번호가 무효가 된다.
// 메신저 문구는 dm_detail(+ dm_pending)로 가른다 — dm_sent_at 은 «재발급 필요» 갈래에도 찍혀 있어 그것만으론 못 가른다.
// 화면은 폴링하지 않는다 — «메신저 보냄»은 상세를 다시 열어야 보인다.
// 🔴 발급·재발급은 확인창 앞에서 다시 읽는다 — 다시 읽기는 빠른 안내용 · 서버도 expected_revision 으로 막는다(어긋나면 409).
// 불러오기 404(J1 없는 서버) = 계정 없음 · 그 밖의 실패 = 경고만(살아 있는 계정을 «없음»으로 잘못 보이지 않게).
// «확인할 메뉴» — 발급·재발급 때 고른 메뉴를 그 DEV 계정 권한(menu_access)에 true 로 넣는다(요청자 권한 위에 · 서버가 판정).
//   목록 = 서버 GET /api/devreq/qa-menus(발급자 기준 · 시스템 관리자 전용 메뉴는 시스템 관리자에게만) · 목에 qaMenus 가 없으면 목록 없음.
//   기본 체크 = 직전 발급 때 고른 것(qa_menu_keys)과 지금 목록의 교집합 · 고른 적이 없으면(null) 요청의 사용 위치를 메뉴 키로
//   바꾼 것(menuKeyForUsageLocation) · 못 찾으면 빈칸. 안 골라도 된다(지금처럼 요청자 권한 복사만).
import { useEffect, useRef, useState } from 'react';
import { devreqAPI } from '../../api/client';
import { confirmDialog } from '../../components/AppDialog';
import { COLORS, btn } from '../../utils/uiStyles';
import { fmtKstShort, parseServerUtc } from '../../utils/kstTime';
import { DEFAULT_NAV } from '../../utils/sidebarMenu';
import { errorText } from './devreqLabels';

export const QA_TITLE = 'DEV 확인 계정';
export const ISSUE_LABEL = 'DEV 확인 계정 발급';
export const ISSUE_CONFIRM = 'DEV 에 계정이 만들어지면(보통 1~2분) 연결된 요청자에게 메신저 DM 으로 아이디·비밀번호를 보냅니다. 사내망에서만 열리며 7일 뒤 자동 삭제됩니다.';
export const REISSUE_TAIL = ' 1~2분 안에 이전 비밀번호로는 로그인할 수 없게 됩니다.';
export const REVOKE_CONFIRM = 'DEV 확인 계정을 회수합니다. 1~2분 안에 DEV 에서 로그인할 수 없게 됩니다.';
export const LOAD_FAILED = 'DEV 확인 계정 상태를 불러오지 못했습니다 — 상세를 다시 열어 주세요';
export const STALE_NOTICE = '다른 사람이 방금 바꿨습니다 — 줄을 확인하고 다시 눌러 주세요';
export const UNLINKED_NOTICE = '요청자 미연결 — 먼저 요청자를 연결해 주세요';
export const EXPIRED_NOTICE = '기한 지남(DEV 삭제 대기)';
// 메신저 DM 상태 문구(상태 글자 옆 · 다른 요소) — 서버 dm_detail·dm_pending(routers/devreq.py _qa_view)로 가른다.
export const DM_WAITING = '반영되면 메신저로 보냅니다';
export const DM_SENT = '메신저 보냄';
export const DM_DEAD = '메신저를 보낼 수 없습니다 — 재발급이 필요합니다';
export const DM_UNKNOWN = '메신저 상태 확인 불가(옛 발급) — 받지 못했으면 재발급해 주세요';
export const DM_SENDING = '메신저 보내는 중';
export const DM_RETRY_TAIL = ' · 재시도 중';
export const MENU_TITLE = '확인할 메뉴';
export const MENU_NOTE = '고른 메뉴는 발급·재발급 때 이 DEV 계정에 권한으로 들어갑니다(요청자 권한에 더해 · DEV 에만).';
const DM_SENT_DETAILS = ['sent', 'sent_at_issue'];
const DM_DEAD_DETAILS = ['decrypt_failed', 'no_requester', 'stale_enc', 'gave_up'];
const ACT_FAILED = '처리하지 못했습니다.';
// 서버 status → 글자(pending·applied·error 만 «살아 있는» 계정 · revoked·deleted 는 발급 줄).
const LIVE_STATUS_LABELS = { pending: 'DEV 반영 대기', applied: 'DEV 반영됨', error: 'DEV 반영 오류' };
const LIVE_STATUSES = Object.keys(LIVE_STATUS_LABELS);
const QA_KEYS = [
  'login_email', 'expires_at', 'status', 'revision', 'synced_at', 'sync_detail', 'dm_sent_at', 'dm_detail', 'dm_pending',
  'qa_menu_keys',
];

const isObj = (value) => !!value && typeof value === 'object';

// 사용 위치(서버 devreq_rules.usage_location_value — 앱 안 경로 또는 https 주소) → 메뉴 키 하나(처음 발급의 기본 체크).
//   https 는 게이트웨이 자기 호스트일 때만 호스트를 뗀다(다른 호스트면 대응 없음) · 쿼리·# 는 뗀다 ·
//   사이드바 기본 메뉴(DEFAULT_NAV)의 경로와 마디 단위로 가장 긴 앞부분이 맞는 것 · '/'(AI 채팅)은 대응하지 않는다 ·
//   allowed(서버 목록의 키 집합)에 있는 키만 · 못 찾으면 null.
//   센터 메뉴 넷은 App.jsx 라우트(MenuRoute menuKey) 경로를 함께 든다 — DEFAULT_NAV 에 그 키가 없는 판(센터 항목을 사이드바가
//   실행 중에 넣던 때)에도 센터 화면 사용 위치가 기본 체크되게(DEFAULT_NAV 에 같은 키가 있으면 그쪽이 먼저 · 중복은 버린다).
const CENTER_ROUTE_PATHS = [
  { key: 'center-all', path: '/center-costs' },
  { key: 'center-daily', path: '/center-daily' },
  { key: 'center-shippers', path: '/center-shippers' },
  { key: 'center-perf', path: '/center-performance' },
];
const NAV_PATHS = [...DEFAULT_NAV, ...CENTER_ROUTE_PATHS]
  .filter((x) => x && typeof x.key === 'string' && typeof x.path === 'string' && x.path !== '/')
  .filter((x, i, all) => all.findIndex((y) => y.key === x.key) === i);
const pathSegments = (p) => p.split('/').filter(Boolean);
export function menuKeyForUsageLocation(location, allowed, selfHost) {
  if (typeof location !== 'string' || !(allowed instanceof Set)) return null;
  let path = location.trim();
  if (/^https:\/\//i.test(path)) {
    let url;
    try {
      url = new URL(path);
    } catch (e) {
      return null;
    }
    const host = selfHost ?? (typeof window !== 'undefined' ? window.location.host : '');
    if (!host || url.host !== host) return null;
    path = url.pathname;
  } else if (!path.startsWith('/') || path.startsWith('//')) {
    return null;
  }
  const segs = pathSegments(path.split(/[?#]/)[0]);
  let best = null;
  let bestLen = 0;
  NAV_PATHS.forEach((nav) => {
    if (!allowed.has(nav.key)) return;
    const navSegs = pathSegments(nav.path);
    if (navSegs.length === 0 || navSegs.length <= bestLen || navSegs.length > segs.length) return;
    if (navSegs.every((s, i) => s === segs[i])) {
      best = nav.key;
      bestLen = navSegs.length;
    }
  });
  return best;
}
// 서버 목록 → [{key, label}](글자 키·이름만).
const menuList = (data) => (Array.isArray(data)
  ? data.filter((m) => isObj(m) && typeof m.key === 'string' && m.key && typeof m.label === 'string')
    .map((m) => ({ key: m.key, label: m.label }))
  : []);
// 기본 체크 — 직전 선택(qa_menu_keys) ∩ 지금 목록 · 직전 선택이 없으면(null) 사용 위치 대응 하나 · 그 밖은 빈칸.
const defaultMenuKeys = (acct, menus, usageLocation) => {
  const allowed = new Set(menus.map((m) => m.key));
  if (isObj(acct) && Array.isArray(acct.qa_menu_keys)) return acct.qa_menu_keys.filter((key) => allowed.has(key));
  const key = menuKeyForUsageLocation(usageLocation, allowed);
  return key ? [key] : [];
};
// 메신저 문구 — pending 은 늘 «대기» · applied 는 dm_detail·dm_pending 으로 보냄/재발급 필요/확인 불가/보내는 중 ·
// error 는 문구 없음(사유를 따로 보인다).
export const dmNote = (acct) => {
  if (!isObj(acct)) return '';
  if (acct.status === 'pending') return DM_WAITING;
  if (acct.status !== 'applied') return '';
  const detail = typeof acct.dm_detail === 'string' ? acct.dm_detail : null;
  if (detail && DM_SENT_DETAILS.includes(detail)) return DM_SENT;
  if (detail && DM_DEAD_DETAILS.includes(detail)) return DM_DEAD;
  // 옛 코드가 발급한 행 — 암호문도 dm_detail 도 없다(채움은 첫 배포 한 번뿐).
  if (detail === null && acct.dm_pending === false) return DM_UNKNOWN;
  return detail && detail.startsWith('retry:') ? `${DM_SENDING}${DM_RETRY_TAIL}` : DM_SENDING;
};
// 응답 → 상태 값(10개 키만) · 객체가 아니면 null(계정 없음).
const pick = (d) => {
  if (!isObj(d) || Array.isArray(d)) return null;
  const out = {};
  QA_KEYS.forEach((key) => { out[key] = d[key]; });
  return out;
};

const sectionStyle = {
  marginBottom: '12px', padding: '8px 12px', borderRadius: '10px', border: `1px solid ${COLORS.border}`,
  display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px',
};
const headStyle = { fontSize: '12px', fontWeight: 600, color: COLORS.textSub };
const textStyle = { fontSize: '13px', color: COLORS.text, overflowWrap: 'anywhere', minWidth: 0 };
const noteStyle = { fontSize: '11px', color: COLORS.textSub, overflowWrap: 'anywhere' };
const alertStyle = { flexBasis: '100%', fontSize: '12px', color: COLORS.dangerText, overflowWrap: 'anywhere' };
const menuBoxStyle = {
  flexBasis: '100%', minWidth: 0, margin: 0, padding: '6px 10px 8px', border: `1px solid ${COLORS.borderSoft}`, borderRadius: '8px',
};
const menuListStyle = { display: 'flex', flexWrap: 'wrap', gap: '4px 12px', margin: '2px 0 4px' };
const menuItemStyle = { fontSize: '12px', display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' };

// 바깥(훅 없음) — 목에 qaAccount 가 없으면(기존 시험) 아무것도 그리지 않는다.
export default function DevRequestQaAccount(props) {
  if (typeof devreqAPI?.qaAccount !== 'function') return null;
  return <QaAccountLine {...props} />;
}

function QaAccountLine({ item, onChanged }) {
  const [acct, setAcct] = useState(undefined);   // undefined = 불러오는 중 · null = 없음 · 'failed' = 불러오기 실패 · 객체
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [menus, setMenus] = useState([]);        // «확인할 메뉴» 후보(서버 목록) — 못 받으면 빈 목록(목록 없이 지금처럼 발급)
  const [picked, setPicked] = useState(null);    // null = 아직 손대지 않음(기본 체크를 따른다) · 배열 = 고른 키
  const busyRef = useRef(false);
  const aliveRef = useRef(true);

  useEffect(() => {
    aliveRef.current = true;
    return () => { aliveRef.current = false; };
  }, []);

  // 후보 목록 — 발급자 기준(서버). 다른 화면의 목에 qaMenus 가 없으면 부르지 않는다.
  useEffect(() => {
    if (typeof devreqAPI?.qaMenus !== 'function') return undefined;
    let alive = true;
    Promise.resolve()
      .then(() => devreqAPI.qaMenus())
      .then((r) => { if (alive) setMenus(menuList(r?.data)); })
      .catch(() => { if (alive) setMenus([]); });
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    let alive = true;
    // 부르는 중 던져도 사슬 안이라 catch 로 간다.
    Promise.resolve()
      .then(() => devreqAPI.qaAccount(item.id))
      .then((r) => { if (alive) setAcct(pick(r?.data)); })
      .catch((err) => { if (alive) setAcct(err?.response?.status === 404 ? null : 'failed'); });
    return () => { alive = false; };
  }, [item.id]);

  const fail = async (err) => {
    const message = await errorText(err, ACT_FAILED);
    if (aliveRef.current) setError(message);
  };

  // 지금 체크된 키(목록 순서) — 손댔으면 그것, 아니면 기본 체크.
  const chosenKeys = () => {
    const base = new Set(picked ?? defaultMenuKeys(acct, menus, item.usage_location));
    return menus.filter((m) => base.has(m.key)).map((m) => m.key);
  };
  const toggleMenu = (key) => {
    const next = new Set(chosenKeys());
    if (next.has(key)) next.delete(key);
    else next.add(key);
    setPicked(menus.filter((m) => next.has(m.key)).map((m) => m.key));
  };

  // 발급·재발급 — 다시 읽어 화면과 모양(없음↔있음)·revision 이 같을 때만 확인창으로(status 는 DEV 동기화가 바꾸므로 보지 않는다).
  const issue = async () => {
    if (busyRef.current) return;
    busyRef.current = true;
    setBusy(true);
    setError('');
    try {
      let fresh;
      try {
        const r = await devreqAPI.qaAccount(item.id);
        fresh = pick(r?.data);
      } catch (err) {
        if (err?.response?.status !== 404) {
          await fail(err);
          return;
        }
        fresh = null;
      }
      if (!aliveRef.current) return;
      if (isObj(fresh) !== isObj(acct) || (isObj(fresh) && fresh.revision !== acct.revision)) {
        setAcct(fresh);
        setError(STALE_NOTICE);
        return;
      }
      // 화면에 행이 있으면(기한 지남·회수·삭제 포함) 서버는 재발급한다 — 이전 비밀번호 문장을 붙인다.
      if (!(await confirmDialog(isObj(acct) ? `${ISSUE_CONFIRM}${REISSUE_TAIL}` : ISSUE_CONFIRM))) return;
      const menuKeys = chosenKeys();
      const r = await devreqAPI.issueQaAccount(item.id, isObj(acct) ? acct.revision : null, menuKeys);
      if (!aliveRef.current) return;
      // 발급 응답에는 고른 메뉴가 없다 — 보낸 것을 «직전 선택»으로 두고 기본 체크로 돌아간다(안 골랐으면 null).
      const issued = pick(r?.data);
      if (isObj(issued)) issued.qa_menu_keys = menuKeys.length ? menuKeys : null;
      setAcct(issued);
      setPicked(null);
      onChanged?.();
    } catch (err) {
      await fail(err);
    } finally {
      busyRef.current = false;
      if (aliveRef.current) setBusy(false);
    }
  };

  // 회수 — 다시 읽지 않는다(이미 회수된 행은 서버가 200 으로 그대로 돌려준다) · 응답이 비면 status 만 revoked.
  const revoke = async () => {
    if (busyRef.current) return;
    busyRef.current = true;
    setBusy(true);
    setError('');
    try {
      if (!(await confirmDialog(REVOKE_CONFIRM, { danger: true }))) return;
      const r = await devreqAPI.revokeQaAccount(item.id);
      if (!aliveRef.current) return;
      setAcct(pick(r?.data) ?? ((prev) => (isObj(prev) ? { ...prev, status: 'revoked' } : prev)));
      onChanged?.();
    } catch (err) {
      await fail(err);
    } finally {
      busyRef.current = false;
      if (aliveRef.current) setBusy(false);
    }
  };

  if (acct === undefined) return null;
  if (acct === 'failed') {
    return (
      <section aria-label={QA_TITLE} style={sectionStyle}>
        <span style={headStyle}>{QA_TITLE}</span>
        <div role="alert" style={alertStyle}>{LOAD_FAILED}</div>
      </section>
    );
  }

  // live/expired 는 브라우저 시계로 가른다 · 기한을 읽을 수 없으면 둘 다 아니다(발급 줄).
  const now = Date.now();
  const exp = isObj(acct) ? parseServerUtc(acct.expires_at) : null;
  const liveStatus = isObj(acct) && LIVE_STATUSES.includes(acct.status);
  const live = liveStatus && !!exp && exp.getTime() > now;
  const expired = liveStatus && !!exp && exp.getTime() <= now;
  const canIssue = item.withdrawn !== true && (item.status === '테스트' || item.status === '완료');
  const unlinked = item.requester_id === null;
  // 살아 있는 계정은 늘 그린다(회수 길을 막지 않는다) · 아니면 발급할 수 있을 때만.
  if (!live && !canIssue) return null;

  const syncDetail = live && acct.status === 'error' && acct.sync_detail ? String(acct.sync_detail) : '';
  const dmText = live ? dmNote(acct) : '';
  // «확인할 메뉴» — 발급·재발급을 할 수 있을 때만(회수만 남은 줄에는 없다).
  const showMenus = canIssue && menus.length > 0;
  const chosen = new Set(showMenus ? chosenKeys() : []);
  return (
    <section aria-label={QA_TITLE} style={sectionStyle}>
      <span style={headStyle}>{QA_TITLE}</span>
      {live && (
        <>
          <span style={textStyle}>
            {`${acct.login_email || ''} · ~${fmtKstShort(acct.expires_at)} 까지 · `}
            <span title={syncDetail || undefined}>{LIVE_STATUS_LABELS[acct.status]}</span>
            {/* 상태 글자와 메신저 문구는 다른 요소 — 상태 글자만으로 찾는 곳이 그대로 맞게. */}
            {dmText && ' · '}
            {dmText && <span>{dmText}</span>}
          </span>
          {/* 휴대폰에서는 title 이 안 보인다 — 사유를 작은 글자로도. */}
          {syncDetail && <span style={noteStyle}>{syncDetail}</span>}
          {canIssue && (
            <button type="button" onClick={issue} disabled={busy || unlinked} style={btn('secondary', 'sm')}>재발급</button>
          )}
          <button type="button" onClick={revoke} disabled={busy} style={btn('danger', 'sm')}>회수</button>
        </>
      )}
      {!live && expired && <span style={textStyle}>{EXPIRED_NOTICE}</span>}
      {!live && (
        <button type="button" onClick={issue} disabled={busy || unlinked} style={btn('primary', 'sm')}>{ISSUE_LABEL}</button>
      )}
      {canIssue && unlinked && <span style={noteStyle}>{UNLINKED_NOTICE}</span>}
      {showMenus && (
        <fieldset style={menuBoxStyle} disabled={busy}>
          <legend style={headStyle}>{MENU_TITLE}</legend>
          <div style={menuListStyle}>
            {menus.map((m) => (
              <label key={m.key} style={menuItemStyle}>
                <input type="checkbox" checked={chosen.has(m.key)} onChange={() => toggleMenu(m.key)} />
                {m.label}
              </label>
            ))}
          </div>
          <div style={noteStyle}>{MENU_NOTE}</div>
        </fieldset>
      )}
      {error && <div role="alert" style={alertStyle}>{error}</div>}
    </section>
  );
}
